import { render, staticRenderFns } from "./ChatGPTObject.vue?vue&type=template&id=12eb7757&scoped=true&"
import script from "./ChatGPTObject.vue?vue&type=script&lang=js&"
export * from "./ChatGPTObject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12eb7757",
  null
  
)

export default component.exports